import { useSelector } from 'react-redux'
import { dueDateDifferenceText } from '../../../../lib/dateScripts'
import { formatDate, formatDateLocal, truncateString } from '../../../../lib/script'
import { notePriorityOptions, noteTypesOptions } from '../../../../lib/systemData'
import Button from '../../../common/Button'
import Tag from '../../../fragments/Tag'
import DeleteNote, { DeletedNoteMeta } from './DeleteNote'
import { isDeletedNote, isDeletedTask } from '../../../../lib/noteDelete'
import { useUserTabEditPermissionDisabled } from '../../../../lib/usersPermissions'

import classes from './NotesVertical.module.css'


const NotesVerticalItem = ({itemData, hasResolve, openResolveTask, setitemToResolve, caseData}) => {

    const user = useSelector(state => state.user.user)
    const canDeleteNotesTasks = useUserTabEditPermissionDisabled('notes_tasks_delete')

    if (!itemData || isDeletedTask(itemData)) {
        return null
    }

    const deletedNote = isDeletedNote(itemData)
    const showDelete = !deletedNote && canDeleteNotesTasks
    const showResolve = !deletedNote && itemData.is_task && hasResolve && !itemData.assignee_resolved && !itemData.resolved
    const showComplete = !deletedNote && itemData.is_task && hasResolve && itemData.user?.id == user?.id && itemData.assignee_resolved && !itemData.resolved

    function resolveTask() {
        if (openResolveTask) {
            openResolveTask()
        }
        if (setitemToResolve) {
            setitemToResolve(itemData)
        }
    }

    return <>
        {itemData && <div className={`${classes.item} ${deletedNote ? classes.deleted_item : ''}`}>
            {itemData.is_task ? <>
                    {/* ############### task layout #################### */}
                    <div className={classes.item_header}>
                        <div className={classes.item_name_container}>
                            {itemData.priority && <>
                                <Tag type={notePriorityOptions().find(item => item.value == itemData.priority)?.color}>{itemData.priority}</Tag>
                            </>}
                            {itemData.note_type_id && noteTypesOptions()?.find(item => item.value == itemData.note_type_id)?.note_actions?.find(item => item.id == itemData.note_action_id)?.name}
                        </div>
                        <div className={classes.item_date}>{itemData.due_date && <>
                            {dueDateDifferenceText(itemData.due_date)}
                        </>}</div>
                    </div>
                    <div className={classes.item_row}>
                        "{truncateString(itemData.note, 130)}"
                    </div>

                    <div className={classes.item_row}>
                        {itemData.assignee_users && itemData.assignee_users.length > 0 && <>
                            Assign to  <strong>
                            {itemData.assignee_users.map(item => (
                                <span key={item.id} className={classes.assignee}>{item.name}</span>
                            ))}
                            </strong>
                        </>}
                        {itemData.assignee_teams && itemData.assignee_teams.length > 0 && <>
                            Assign to  <strong>
                            {itemData.assignee_teams.map(item => (
                                <span key={item.id} className={classes.assignee}>{item.name}</span>
                            ))}
                            </strong>
                        </>}
                    </div>
                    
                    {(showResolve || showComplete || showDelete) && <div className={`${classes.item_row} flex-container gap-5`}>
                        {showResolve && <>
                            <Button click={resolveTask} btnStyle={'btn_small'}>Resolve</Button>
                        </>}
                        {showComplete && <>
                            <Button click={resolveTask} btnStyle={'btn_small'}>Complete</Button>
                        </>}
                        {showDelete && <DeleteNote itemData={itemData} caseData={caseData} />}
                    </div>}
                </>
                :
                <>
                    {/* ################## note layout ########################### */}
                    <div className={classes.item_header}>
                        <div className={classes.item_name_container}>
                            <Tag type={(itemData.is_task == 0) || itemData.is_task == false ? 'note' : 'task'}>{(itemData.is_task == 0) || itemData.is_task == false ? 'note' : 'task'}</Tag>
                            <div className={classes.item_name}>{itemData.user && itemData.user.name}</div>
                        </div>
                        <div className={classes.item_date}>{itemData.created_at && <>{formatDate(itemData.created_at)}</>}</div>
                    </div>
                    <div className={classes.item_row}>
                        "{truncateString(itemData.note, 130)}"
                    </div>
                    {deletedNote && <DeletedNoteMeta itemData={itemData} />}
                    {itemData.note_action && !deletedNote && <div className={classes.item_row}>
                        <span className={classes.item_action}>{itemData.note_action.name}</span> until <span className={classes.item_duedate}>{formatDateLocal(itemData.due_date)}</span>   
                    </div>}
                    {showDelete && <div className={classes.item_row}>
                        <DeleteNote itemData={itemData} caseData={caseData} />
                    </div>}
                </>}

            {/* {!inWorkQ && <>
                <div className={classes.item_header}>
                    <div className={classes.item_name_container}>
                        <Tag type={(itemData.is_task == 0) || itemData.is_task == false ? 'note' : 'task'}>{(itemData.is_task == 0) || itemData.is_task == false ? 'note' : 'task'}</Tag>
                        <div className={classes.item_name}>{itemData.user && itemData.user.name}</div>
                    </div>
                    <div className={classes.item_date}>{itemData.created_at && <>{formatDate(itemData.created_at)}</>}</div>
                </div>
                <div className={classes.item_row}>
                    "{truncateString(itemData.note, 130)}"
                </div>
                {itemData.note_action && <div className={classes.item_row}>
                    <span className={classes.item_action}>{itemData.note_action.name}</span> until <span className={classes.item_duedate}>{formatDateLocal(itemData.due_date)}</span>   
                </div>}
                {itemData.is_task == 1 && hasResolve && <div className={classes.item_row}>
                    <Button click={resolveTask} btnStyle={'btn_small'}>Resolve</Button>
                </div>}
            </>} */}

            {/* {inWorkQ && <>
                {itemData.is_task == 1 ? <>
                    <div className={classes.item_header}>
                        <div className={classes.item_name_container}>
                            {itemData.priority && <>
                                <Tag type={notePriorityOptions().find(item => item.value == itemData.priority)?.color}>{itemData.priority}</Tag>
                            </>}
                            {itemData.note_type_id && noteTypesOptions()?.find(item => item.value == itemData.note_type_id)?.note_actions?.find(item => item.id == itemData.note_action_id)?.name}
                        </div>
                        <div className={classes.item_date}>{itemData.due_date && <>due by {formatDate(itemData.due_date)}</>}</div>
                    </div>
                    <div className={classes.item_row}>
                        "{truncateString(itemData.note, 130)}"
                    </div>

                    <div className={classes.item_row}>
                        {itemData.assignee_users && itemData.assignee_users.length > 0 && <>
                            Assign to  <strong>
                            {itemData.assignee_users.map(item => (
                                <span key={item.id}>{item.name}</span>
                            ))}
                            </strong>
                        </>}
                        {itemData.assignee_teams && itemData.assignee_teams.length > 0 && <>
                            Assign to  <strong>
                            {itemData.assignee_teams.map(item => (
                                <span key={item.id}>{item.name}</span>
                            ))}
                            </strong>
                        </>}
                    </div>
                    
                    {itemData.is_task == 1 && hasResolve && <div className={classes.item_row}>
                        <Button click={resolveTask} btnStyle={'btn_small'}>Resolve</Button>
                    </div>}
                </>
                :
                <>
                    <div className={classes.item_header}>
                        <div className={classes.item_name_container}>
                            <Tag type={(itemData.is_task == 0) || itemData.is_task == false ? 'note' : 'task'}>{(itemData.is_task == 0) || itemData.is_task == false ? 'note' : 'task'}</Tag>
                            <div className={classes.item_name}>{itemData.user && itemData.user.name}</div>
                        </div>
                        <div className={classes.item_date}>{itemData.created_at && <>{formatDate(itemData.created_at)}</>}</div>
                    </div>
                    <div className={classes.item_row}>
                        "{truncateString(itemData.note, 130)}"
                    </div>
                    {itemData.note_action && <div className={classes.item_row}>
                        <span className={classes.item_action}>{itemData.note_action.name}</span> until <span className={classes.item_duedate}>{formatDateLocal(itemData.due_date)}</span>   
                    </div>}
                </>}
            </>} */}
            


        {/* #############   old display ############# */}
            {/* <div className={classes.item_header}>
                <div className={classes.item_name_container}>
                    <Tag type={(itemData.is_task == 0) || itemData.is_task == false ? 'note' : 'task'}>{(itemData.is_task == 0) || itemData.is_task == false ? 'note' : 'task'}</Tag>
                    <div className={classes.item_name}>{itemData.user && itemData.user.name}</div>
                </div>
                <div className={classes.item_date}>{itemData.created_at && <>{formatDate(itemData.created_at)}</>}</div>
            </div>
            <div className={classes.item_row}>
                "{truncateString(itemData.note, 130)}"
            </div>
            {itemData.note_action && <div className={classes.item_row}>
                <span className={classes.item_action}>{itemData.note_action.name}</span> until <span className={classes.item_duedate}>{formatDateLocal(itemData.due_date)}</span>   
            </div>}
            {itemData.is_task == 1 && hasResolve && <div className={classes.item_row}>
                <Button click={resolveTask} btnStyle={'btn_small'}>Resolve</Button>
            </div>}            */}
        </div>}
    </>
}

export default NotesVerticalItem